<template>
    <div class="mt-[58px] lg:mt-20 py-14 lg:py-20">
        <div class="container">
            <div v-if="is_edit" class="lg:max-w-[600px] mt-1">
                <v-text option_key="contact_address_embed" />
            </div>
            <div class="flex flex-col lg:flex-row gap-14 lg:gap-17">
                <div class="-mt-15 lg:mt-0 mx-[-15px] lg:mx-0 lg:flex-1 h-[400px] lg:h-[700px]">
                    <iframe class="w-full h-full" :src="dataAddressEmbed[0]?.option_value"></iframe>
                </div>
                <div class="lg:w-[480px]">
                    <div class="text-primary-75 text-[20px] lg:text-[36px] font-bold uppercase">
                        <v-text option_key="contact_title" />
                    </div>
                    <div class="py-8 flex flex-col gap-3 border-b border-solid border-[#EAEAEA]">
                        <v-list option_key="contact_list1" :icons="[]" :fields="['image', 'text']" v-slot="{ item }">
                            <div class="flex items-center gap-3">
                                <div class="min-w-5 min-h-5">
                                    <v-image :icons="[]" :option_key="item['image']" class="w-full h-full"></v-image>
                                </div>
                                <div class="text-[14px] lg:text-[16px] text-black-800">
                                    <v-text :option_key="item['text']" />
                                </div>
                            </div>
                        </v-list>
                    </div>
                    <div class="pt-8 text-black-800 font-bold">
                        <v-text option_key="contact_title2" />
                    </div>
                    <div class="pt-8 flex flex-col gap-2">
                        <div v-for="index in 5" class="flex items-start gap-2">
                            <div class="min-w-2.5 min-h-2.5 bg-red rounded-[50%] mt-2"></div>
                            <div class="flex gap-2 flex-col sm:flex-row">
                                <div class="text-black-800 text-[14px] lg:text-[16px]">
                                    <v-text :option_key="`contact_list2-${index}`" />
                                </div>
                                <div class="">
                                    <v-list
                                        :option_key="`contact_list2_text${index}`"
                                        :icons="[]"
                                        :link="false"
                                        :fields="['text']"
                                        v-slot="{ item }"
                                    >
                                        <div class="text-primary-75 text-[14px] lg:text-[16px] mb-1">
                                            <v-text :option_key="item['text']" :link="true" />
                                        </div>
                                    </v-list>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
const is_edit = inject('is_edit')
const data_live_editor = inject('data_live_editor')
const dataAddressEmbed = computed(() => {
    return data_live_editor.value.filter((item) => {
        return item.option_key.includes('TEXT__contact_address_embed')
    })
})
useDirectusCollectionSeo('contact', {})
</script>

<style></style>
